import React, { useRef } from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { logout } from "../store/authSlice";
import { AuthService } from "../services/AuthService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import useModalCloseHook from "../hooks/useModalCloseHook";

const LogoutModal = ({ setIsLogout }) => {
      const modalRef=useRef(null);
      const handleClose=()=>{
        setIsLogout(false);
      }
      useModalCloseHook(modalRef,handleClose)
      
    const dispatch=useDispatch();
    const navigate=useNavigate();

    const handleLogOut=async()=>{
      try {
          const response=await AuthService.logOut();
          if(response){
            dispatch(logout());
            sessionStorage.removeItem('header');
            navigate('/login');
            setIsLogout(false);
          }
      } catch (error) {
        toast.error(error?.message)
      }
    }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div ref={modalRef} className="bg-white rounded-md shadow-lg max-w-sm w-full p-6 relative z-50">
        {/* Icon and Title */}
        <div className="flex items-center gap-3">
          <FaExclamationTriangle className="text-yellow-500 w-5 h-5" />
          <h2 className="text-lg font-semibold text-gray-800">Confirm Logout</h2>
        </div>

        {/* Message */}
        <p className="text-[15px] text-gray-600 mt-3 font-semibold  ">
          Are you sure you want to Log out?
        </p>

        {/* Actions */}
        <div className="mt-6 flex justify-end gap-3">
          <Button
            onClick={()=>setIsLogout(false)}
            variant="outlined"
            className="  !text-gray-700 !bg-white !capitalize !w-[100px] !font-medium  !border !border-gray-300"
          >
            Cancel
          </Button>
          <Button
            onClick={handleLogOut}
            variant="contained"
            className=" !bg-zinc-800 !capitalize !w-[100px] !font-semibold !text-white hover:!bg-red-700 "
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
